import { type ReactNode } from "react";
import { BackArrowIcon, Help_1Icon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { Footer } from "@vega-core/components/Layout/Footer/Footer";
import { GroupedMenu } from "@vega-core/components/Navigation/GroupedMenu/GroupedMenu";
import { type MenuGroupConfig } from "@vega-core/components/Navigation/GroupedMenu/types";
import { m } from "@vega-core/paraglide/messages";
import { getIsLPCoInvestPortal } from "@vega-core/utils/global";

import { CommonPaths } from "../../../paths";

type Props = {
  menuConfig: MenuGroupConfig[];
  orgSelector: ReactNode;
  onHelpClick: VoidFunction;
  children: ReactNode;
};

export function DesktopShell({
  menuConfig,
  orgSelector,
  onHelpClick,
  children,
}: Props) {
  const isLPCoInvestPortal = getIsLPCoInvestPortal();

  return (
    <div className="flex h-dvh bg-background/primary md:px-10">
      <aside className="flex h-dvh shrink-0 flex-col w-64 bg-background/primary">
        <div className="flex flex-1 flex-col overflow-y-auto py-4 gap-6">
          <div className="flex flex-col gap-4 px-3">
            <ThemedButton
              className="px-0"
              dataTestId="settings-go-back-home"
              route={CommonPaths.Home}
              variant="tertiary"
            >
              <div className="flex items-center gap-2">
                <BackArrowIcon />
                {m.btn_back()}
              </div>
            </ThemedButton>
            <p className="body-base-semibold px-3 text-text/primary">
              {m.titles_settings()}
            </p>
          </div>
          {orgSelector}
          <div className="[&_[data-testid=menu-group-container]]:border-0">
            <GroupedMenu config={menuConfig} />
          </div>
        </div>
      </aside>

      <div className="flex flex-1 flex-col">
        {isLPCoInvestPortal ? null : (
          <div className="flex items-center justify-end p-4 shrink-0">
            <ThemedButton
              dataTestId="need-help-button"
              icon={<Help_1Icon />}
              onClick={onHelpClick}
              variant="secondary"
            >
              {m.btn_needHelp()}
            </ThemedButton>
          </div>
        )}
        <div className="flex flex-1 flex-col overflow-y-auto p-13">
          <div className="w-full flex-1 mx-auto max-w-5xl">{children}</div>
          <Footer isLoggedIn />
        </div>
      </div>
    </div>
  );
}
